import styled from '@emotion/styled';

export const PickerBody = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing[16],
}));
